module.exports = __webpack_public_path__ + "img/safe_move01.eec537c3.png";